import { atom, useAtom, useAtomValue } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { lruCache } from "@/utils/persistedState";

const historyAtom = atomWithStorage("blis.search.history", [] as string[]);

const searchQueryString = atom("", (_get, set, value: string) => {
  set(searchQueryString, value);
  if (value) {
    set(historyAtom, (prev) => {
      return lruCache(prev, value);
    });
  }
});

export function useSearchQuery() {
  return useAtom(searchQueryString);
}

export function useSearchHistory() {
  return useAtomValue(historyAtom);
}
